<template>
    <div>
        <button
            class="bg-white inline-flex items-center pl-14 pr-12 py-8 rounded-6 border border-primary-20 text-primary hover:bg-primary-5"
            @click="addingNewTemplate = true"
        >
            <template v-if="template">
                <svg-icon class="max-w-16 max-h-16 mr-8" type="edit"/>
                {{ $t('settings.edit_template') }}
            </template>
            <template v-else>
                <svg-icon class="max-w-16 max-h-16 text-secondary mr-8" type="add-circle"/>
                {{ $t('settings.add_new_template') }}
            </template>
        </button>
        <popup-modal
            custom-classes="w-768"
            v-if="addingNewTemplate"
            :title="template ? $t('settings.edit_template') : $t('settings.add_new_template')"
            @close="addingNewTemplate = false"
        >
            <template
                v-if="!template">
                <new-competence-template
                    :service="service"
                    :template="template"
                    @input="template = $event"
                />
            </template>
            <template
                v-else>
                <module-template-items
                    v-if="template"
                    :template="activeTemplate"
                    :service="service()"
                    @reset="activeTemplate = null"
                />
            </template>

            <div class="flex justify-between mt-16">
                <simple-button display="success" @click="$emit('close')">
                    {{ $t('general.save') }}
                </simple-button>

                <simple-button class="ml-16" display="secondary" @click="$emit('close')">
                    {{ $t('general.close') }}
                </simple-button>
            </div>
        </popup-modal>
    </div>
</template>

<script>
import ModuleTemplateItems from "./ModuleTemplateItems";
import NewCompetenceTemplate from "./applications/NewModuleTemplate";
import PopupModal from "./ui/PopupModal.vue";
import SvgIcon from "./ui/SvgIcon.vue";
import SimpleButton from "./ui/SimpleButton.vue";
import SelectDropdown from "./forms/SelectDropdown.vue";

export default {
    name: "ModuleTemplateEdit",
    components: {
        SvgIcon,
        SelectDropdown,
        PopupModal,
        ModuleTemplateItems,
        NewCompetenceTemplate,
        SimpleButton
    },
    props: {
        service: null,
        template: null
    },
    computed: {},
    data: function () {
        return {
            addingNewTemplate: false,
            activeTemplate: this.template
        }
    }
}
</script>
